module.exports = __webpack_public_path__ + "posture/static/img/high.b1b9878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/high.png
// module id = smaB
// module chunks = 1